import React, { useContext, useEffect, useState } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
import type { To } from 'react-router-dom';
import ConfirmationModal from '../Modal/CorfimationModal';

interface Props {
  message: string;
  when: boolean;
  method: () => void;
}

const PreventLeavePageItem: React.FC<Props> = ({ message, when, method }) => {
  const { navigator } = useContext(UNSAFE_NavigationContext) as any;
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [nextLocationCallback, setNextLocationCallback] = useState<(() => void) | null>(null);

  useEffect(() => {
    if (!when || !navigator) return;

    const originalPush = navigator.push.bind(navigator);
    const originalReplace = navigator.replace.bind(navigator);

    navigator.push = (to: To, state?: any) => {
      if (confirmed) {
        originalPush(to, state);
      } else {
        setModalVisible(true);
        setNextLocationCallback(() => () => originalPush(to, state));
      }
    };

    navigator.replace = (to: To, state?: any) => {
      if (confirmed) {
        originalReplace(to, state);
      } else {
        setModalVisible(true);
        setNextLocationCallback(() => () => originalReplace(to, state));
      }
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [navigator, confirmed, when]);

  const handleConfirm = () => {
    method?.();
    setConfirmed(true);
    setModalVisible(false);
    nextLocationCallback?.();
  };

  return (
    <>
      <ConfirmationModal
        title="Confirmación"
        closable={false}
        visible={modalVisible}
        setVisible={setModalVisible}
        question={message}
        method={handleConfirm}
        loading={false}
      />
    </>
  );
};

export default PreventLeavePageItem;
